import { render, staticRenderFns } from "./LowerBracket.vue?vue&type=template&id=be433ca0&scoped=true&"
import script from "./LowerBracket.vue?vue&type=script&lang=js&"
export * from "./LowerBracket.vue?vue&type=script&lang=js&"
import style0 from "./LowerBracket.vue?vue&type=style&index=0&id=be433ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be433ca0",
  null
  
)

export default component.exports